import { siteInfo, footerData } from '@/mocks/homeData';

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <h4 className="font-heading text-lg text-background-50 mb-3">{siteInfo.name}</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              {footerData.about}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              {footerData.quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(link.href.replace('#', ''));
                    }}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              <span className="text-xs px-2.5 py-1 rounded-full bg-background-800 text-background-300 whitespace-nowrap">91视频</span>
              <span className="text-xs px-2.5 py-1 rounded-full bg-background-800 text-background-300 whitespace-nowrap">97视频</span>
              <span className="text-xs px-2.5 py-1 rounded-full bg-background-800 text-background-300 whitespace-nowrap">51视频</span>
              <span className="text-xs px-2.5 py-1 rounded-full bg-background-800 text-background-300 whitespace-nowrap">久久视频</span>
              <span className="text-xs px-2.5 py-1 rounded-full bg-background-800 text-background-300 whitespace-nowrap">数字视频大全</span>
              <span className="text-xs px-2.5 py-1 rounded-full bg-background-800 text-background-300 whitespace-nowrap">免费高清</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 mb-3">各大数字视频平台战略合作</p>
            <div className="flex flex-wrap gap-2">
              <span className="text-xs px-2.5 py-1 rounded bg-background-800 text-background-400 whitespace-nowrap">平台A</span>
              <span className="text-xs px-2.5 py-1 rounded bg-background-800 text-background-400 whitespace-nowrap">平台B</span>
              <span className="text-xs px-2.5 py-1 rounded bg-background-800 text-background-400 whitespace-nowrap">平台C</span>
              <span className="text-xs px-2.5 py-1 rounded bg-background-800 text-background-400 whitespace-nowrap">平台D</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 {siteInfo.name} - {siteInfo.tagline} | 本站为数字视频平台导航，不存储任何视频内容
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('hero'); }} className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">返回顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}